<app-shopguard-intro></app-shopguard-intro>
<app-shopguard-quote></app-shopguard-quote>
<app-shopguard-inteligent-video></app-shopguard-inteligent-video>
<app-shopguard-how-works></app-shopguard-how-works>
<app-shopguard-compatibility></app-shopguard-compatibility>
<app-shopguard-benefits></app-shopguard-benefits>
